import {RouterView} from "vue-router";
import guest from "./middleware/guest";
import authenticated from "./middleware/authenticated";
import brand from "./middleware/brand";

export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    exact: true,
    component: () => import('../pages/brand/Dashboard'),
    meta: {
      middleware: authenticated,
    },
  },
  {
    path: '/',
    name: 'campaigns.list',
    exact: true,
    component: () => import('../pages/brand/CampaignList'),
    meta: {
      middleware: authenticated,
    },
  },

  {
    path: '/account-settings',
    name: 'account.settings',
    component: () => import('../pages/brand/Account'),
    meta: {
      middleware: authenticated,
      breadcrumb: [{ label: 'My Account' }],
    },
  },
  {
    path: '/campaign/:id',
    name: 'campaign',
    component: () => import('../pages/brand/Campaign'),
    meta: {middleware: [authenticated]},
    children: [
      {
        path: 'details',
        name: 'campaign.details',
        component: RouterView,
        meta: {middleware: [authenticated, brand]},
      },
      {
        path: 'users/:userId',
        name: 'campaign.user',
        component: RouterView,
        meta: {middleware: [authenticated, brand]},
      },
      {
        path: 'applications',
        name: 'campaign.applications',
        component: RouterView,
        meta: {middleware: [authenticated, brand]},
      },
      {
        path: 'applications/:applicationId',
        name: 'campaign.application',
        component: RouterView,
        meta: {middleware: [authenticated, brand]},
      },
    ]
  },
  {
    path: '/register/brand',
    name: 'register.brand',
    component: () => import('../pages/registration/brand/PersonalData.vue'),
    meta: {middleware: guest},
  },
  {
    path: '/register/brand/setup',
    name: 'register.brand.setup',
    component: () => import('../pages/registration/brand/Setup.vue'),
    meta: {middleware: [authenticated, brand]},
  },
  {
    path: '/team',
    name: 'team',
    component: () => import('../pages/Team.vue'),
    meta: {middleware: [authenticated, brand]},
  },
  {
    path: '/brand-settings',
    name: 'brand.settings',
    component: () => import('../pages/BrandSettings.vue'),
    meta: {middleware: [authenticated, brand]},
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('../pages/Products.vue'),
    meta: {middleware: [authenticated, brand]},
    children: [
      {
        path: ':productId',
        name: 'products.product',
        components: {
          product: RouterView
        },
        meta: {middleware: [authenticated, brand]},
      }
    ]
  },
  {
    path: '/shipments',
    name: 'shipments',
    component: () => import('../pages/Shipments.vue'),
    meta: {middleware: [authenticated, brand]},
  },
  {
    path: '/integrations',
    name: 'integrations',
    component: () => import('../pages/Integrations.vue'),
    meta: {middleware: [authenticated, brand]},
  },
  {
    path: '/payments/settings',
    name: 'payments.settings',
    component: () => import('../pages/PaymentSettings.vue'),
    meta: {
      middleware: [authenticated, brand],
      breadcrumb: [{ label: 'Payment settings' }],
    },
  },
  {
    path: '/campaign-create',
    name: 'campaign.create',
    component: () => import('../pages/CampaignCreate.vue'),
    meta: {middleware: [authenticated, brand]},
  },
  {
    path: '/campaign-create/draft/:id',
    name: 'campaign.edit.draft',
    component: () => import('../pages/CampaignCreate.vue'),
    meta: {middleware: [authenticated, brand]},
  },
];
